import { render } from "./OrderSummarySlider.vue?vue&type=template&id=6960de50"
import script from "./OrderSummarySlider.vue?vue&type=script&lang=js"
export * from "./OrderSummarySlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__